module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable03.49f5634a.png";